import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Home, Clapperboard, MessageSquare, User } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { useUnreadMessages } from "@/components/messages/shared";

const items = [
  { to: "/", key: "home", icon: Home, testid: "nav-home" },
  { to: "/feed", key: "feed", icon: Clapperboard, testid: "nav-feed" },
  { to: "/mensagens", key: "messages", icon: MessageSquare, testid: "nav-messages" },
  { to: "/perfil", key: "profile", icon: User, testid: "nav-profile" },
];

export default function BottomNav({ dark = false }) {
  const { t } = useLang();
  const unread = useUnreadMessages();
  const [typing, setTyping] = useState(false);
  useEffect(() => {
    const isField = (el) => el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.tagName === "SELECT") && el.type !== "checkbox" && el.type !== "radio" && el.type !== "file";
    const onIn = (ev) => { if (window.innerWidth < 640 && isField(ev.target)) setTyping(true); };
    const onOut = () => setTimeout(() => setTyping(isField(document.activeElement) && window.innerWidth < 640), 80);
    document.addEventListener("focusin", onIn); document.addEventListener("focusout", onOut);
    return () => { document.removeEventListener("focusin", onIn); document.removeEventListener("focusout", onOut); };
  }, []);
  return (
    <nav
      data-testid="bottom-nav"
      data-hidden={typing}
      aria-label="Navegação principal"
      data-dark={dark}
      className={`fixed bottom-0 inset-x-0 z-50 backdrop-blur-md border-t transition-transform duration-200 ${dark ? "bg-[#0d0d0d]/95 border-white/10" : "bg-white/95 border-zinc-200"} ${typing ? "translate-y-full pointer-events-none" : ""}`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="max-w-2xl mx-auto grid grid-cols-4 px-2 h-14">
        {items.map(({ to, key, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={testid}
            aria-label={key === "messages" && unread > 0 ? `${t(key)} (${unread})` : t(key)}
            className={({ isActive }) => `
              flex flex-col items-center justify-center gap-0.5 h-full px-1 rounded-xl
              transition-all duration-150
              ${isActive ? "text-[#c8102e]" : dark ? "text-white/70 hover:text-white" : "text-zinc-500 hover:text-zinc-900"}
            `}
          >
            {({ isActive }) => (
              <>
                <span className="relative"><Icon size={20} strokeWidth={isActive ? 2.5 : 2} aria-hidden="true" />
                  {key === "messages" && unread > 0 && <span data-testid="nav-messages-badge" className="absolute -top-1.5 -right-2.5 bg-[#c8102e] text-white text-[9px] font-bold rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center">{unread > 99 ? "99+" : unread}</span>}
                </span>
                <span className="text-[10px] font-semibold">{t(key)}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
